import type { GridColumnVisibilityModel } from "@mui/x-data-grid";

export const SENIORITY_FIELD = "nurseStartDate";
export const NURSE_TYPE_FIELD = "nurseType";
export const REQUESTED_AT_FIELD = "requestedAt";

/** Ships hidden; opted into from the Columns picker. Merge into a surface's `defaultVisibility`, don't replace it. */
export const requestedAtDefaultVisibility: GridColumnVisibilityModel = { [REQUESTED_AT_FIELD]: false };

/**
 * Default visibility for the tenure columns on `NursesMatrixGrid`. (The minimized approval popup shares
 * the FIELD constants above but not this rule — at 450px it hides both by default.)
 *
 * Both tenure columns are always BUILT. Seniority is the default tenure column everywhere, so it is absent
 * from the model (absent reads as visible); Contract Type says much the same thing about a nurse, so it
 * ships hidden — while staying in the column picker, where a user can turn it back on. Merge this into a
 * surface's own `defaultVisibility` rather than replacing it.
 */
export const nurseTypeDefaultVisibility: GridColumnVisibilityModel = { [NURSE_TYPE_FIELD]: false };
